import mixpanel from 'mixpanel-browser';
import mixPanelEvents, { MixPanelConstants } from './constants/MixPanelEvents';

export class MixpanelTracking {
    private static _instance: MixpanelTracking;

    public static getInstance(): MixpanelTracking {
        if (MixpanelTracking._instance == null){
            return (MixpanelTracking._instance = new MixpanelTracking)}
        return this._instance;
    }

    public constructor() {
        if (MixpanelTracking._instance)
            {throw new Error("Instance creation of mixpanel is not allowed. use mixpanel.getInstance() instead")}

        if(process.env.NEXT_PUBLIC_APP_ENVIRONMENT !== 'DEVELOPMENT') {
            mixpanel.init(
                process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || '',
                {
                    debug: process.env.NEXT_PUBLIC_MIXPANEL_DEBUG_MODE === 'true',
                    ignore_dnt: true,
                    secure_cookie: true,
                    api_host: "https://api.mixpanel.com"
                }
            )
        }
    }

    protected track(name: string, data: any) {
        if(process.env.NEXT_PUBLIC_APP_ENVIRONMENT !== 'DEVELOPMENT') 
            mixpanel.track(name, data);
    }

    public mapUserToGuestUser(data : any) {
        if(process.env.NEXT_PUBLIC_APP_ENVIRONMENT !== 'DEVELOPMENT') {
            mixpanel.alias(data.email);
            mixpanel.people.set({
                '$email' : data.email,
                '$first_name' : data.first_name,
                '$last_name' : data.last_name
            })
        }
    }

    public identifyUser(email : string) {
        if(process.env.NEXT_PUBLIC_APP_ENVIRONMENT !== 'DEVELOPMENT') 
            mixpanel.identify(email);
    }

    public pageViewed(data : any) {
        this.track(mixPanelEvents.LANDED, data)
    }

    public searched(data : object) {
        this.track(
            mixPanelEvents.SEARCH,
            data
        )
    }

    public authStarted() {
        this.track(
            mixPanelEvents.AUTH_STARTED,
            {}
        )
    }

    public authFinished(data : object = {}) {
        this.track(
            mixPanelEvents.AUTH_FINISHED,
            data
        )
    }

    public loggedOut() {
        this.track(
            mixPanelEvents.LOGGED_OUT,
            {}
        )
    }

    public bid(data : object) {
        this.track(
            mixPanelEvents.BID,
            data
        )
    }

    public landedToPDP(data : object) {
        this.track(
            mixPanelEvents.LANDED_TO_PDP,
            data
        )
    }

    public landedToEnquiryResponse(data : object) {
        this.track(
            mixPanelEvents.LANDED_TO_ENQUIRY_RESPONSE,
            data
        )
    }

    public clickedOnDealCard(data : object) {
        this.track(
            mixPanelEvents.CLICKED_ON_DEAL_CARD,
            data
        )
    }

    public buttonClicked(data : object) {
        this.track(
            mixPanelEvents.BUTTON_CLICKED,
            data
        )
    }

    public formSubmittedEx(data : object, directPurchaseEnquiry : Boolean = false) {
        this.track(
            directPurchaseEnquiry ? mixPanelEvents.DIRECT_PURCHASE_ENQUIRY : mixPanelEvents.FORM_SUBMITTED,
            data
        )
    }

    public formSubmitted(data : object) {
        this.track(
            mixPanelEvents.FORM_SUBMITTED,
            data
        )
    }

    public trackInput(data : object = {}, input = false) {
        this.track(
            input ? mixPanelEvents.INPUT_FILLED : mixPanelEvents.INPUT_FOCUSED,
            data
        )
    }

    public trackSelect(data : object = {}, input = false) {
        this.track(
            input ? mixPanelEvents.SELECT_INPUT_FILLED : mixPanelEvents.SELECT_INPUT_FOCUSED,
            data
        )
    }

    public scrolled(data : object = {}) {
        this.track(
            mixPanelEvents.SCROLLED,
            data
        )
    }

    public apiCalled(data : object = {}) {
        /** Do Nothing */    
    }

    public orderPlaced(data : object = {}) {
        this.track(
            mixPanelEvents.ORDERED,
            data
        )
    }

    public toWhatsAppChat(data : object = {}) {
        this.track(
            mixPanelEvents.TO_WA_CHAT,
            data
        )
    }

    public reset() {
        if(process.env.NEXT_PUBLIC_APP_ENVIRONMENT !== 'DEVELOPMENT') 
            mixpanel.reset();
    }
}